import type { City } from '@/pages/articlesSights/entities/cityArticles/models';
import type { City as EncodedCity } from '@/shared/api/experience';

import { normalizeCityImage } from './cityImage';
import { normalizeCountry } from './country';

/**
 * Преобразует данные из API во внутреннее представление данных города.
 *
 * @param encoded значение из API
 * @returns внутреннее представление
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
export const normalizeCity = (encoded: EncodedCity): City => {
  return {
    id: encoded.id ?? 0,
    nameRu: encoded.name_ru ?? '',
    name1Ru: encoded.name_1_ru ?? '',
    name5Ru: encoded.name_5_ru ?? '',
    nameEn: encoded.name_en ?? '',
    iata: encoded.iata ?? '',
    country: normalizeCountry(encoded.country),
    experienceCount: encoded.experience_count ?? 0,
    excursionsCount: encoded.excursions_count ?? 0,
    toursCount: encoded.tours_count ?? 0,
    inObjPhrase: encoded.in_obj_phrase ?? '',
    acrossObjPhrase: encoded.across_obj_phrase ?? '',
    aboutObjPhrase: encoded.about_obj_phrase ?? '',
    fromObjPhrase: encoded.from_obj_phrase ?? '',
    toObjPhrase: encoded.to_obj_phrase ?? '',
    namePrepositional: encoded.name_prepositional ?? '',
    url: encoded.url ?? '',
    image: normalizeCityImage(encoded.image),
    utcOffset: encoded.utc_offset ?? 0,
    guidesCount: encoded.guides_count ?? 0,
    slug: encoded.slug ?? '',
  };
};
